/*
    Author: Lamiaa Moustafa
    Desc: react bootstrap modal as reusable component
 */

import React from "react";
import { Modal } from "react-bootstrap";
import styled from "styled-components";

const Modal1st2911 = (props) => {
  const { show, handleClose, size, modalTitle } = props;

  return (
    <Modal
      onClose={handleClose}
      size={size}
      show={show}
      onHide={handleClose}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <ModalDiv>
        <Modal.Header closeButton>
          <Modal.Title>{modalTitle}</Modal.Title>
          <p className="btn-modal-close" onClick={() => handleClose()}>
            <i className="fa fa-times text-danger"></i>
          </p>
        </Modal.Header>
        <Modal.Body>{props.children}</Modal.Body>
      </ModalDiv>
    </Modal>
  );
};

export default Modal1st2911;

const ModalDiv = styled.div`
  width: 100%;
  height: 50vh;
  min-height: 600px;
  background-color: var(--whiteGray);
  .modal-header {
    background-color: var(--orange);
    border-radius: 0;
    .modal-title {
      color: var(--white);
      margin-left: 35%;
      font-weight: 400;
    }
  }
  .modal-body {
    padding-top: 2em;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    label {
      margin-left: 13%;
    }
    input {
      margin: 0 auto;
      width: 75%;
      border: 2px solid var(--orange);
    }
  }
  /* div:nth-child(4) { */

  label {
    margin-left: 5%;
    align-self: flex-start;
  }
`;
